import { Component, Input, OnInit } from '@angular/core';
import { ContentfulSectionContent } from 'src/app/core/interfaces/Contentful/ContentfulSectionContent';

@Component({
  selector: 'app-contentful-title',
  templateUrl: './contentful-title.component.html',
  styleUrls: ['./contentful-title.component.scss'],
  standalone: true,
})
export class AppContentfulTitleComponent implements OnInit {
  @Input() contentfulSectionContent: ContentfulSectionContent | undefined;
  title: string | undefined;

  ngOnInit() {
    if (this.contentfulSectionContent) {
      // @TODO: Check how we can differ the different contentful content types without using this any
      const contentfulSectionContent = this.contentfulSectionContent.contentfulContent?.content as any;

      // Article specific titles
      if (contentfulSectionContent && contentfulSectionContent.overview) {
        this.title = contentfulSectionContent.overview.title;
      } else if (contentfulSectionContent && contentfulSectionContent.question) {
        this.title = contentfulSectionContent.question;
      }
    }
  }
}
